import { useCallback } from "react";
import { FormFieldProps } from "../form-field/FormFieldProps";
import styles from "./MultiInput.module.less";
import { DelegatedFormFieldProps, SingleInput } from "./SingleInput";

export interface IndexedInputProps<V, T extends FormFieldProps<V>> extends DelegatedFormFieldProps<V, T> {
  index: number;
  defaultValue?: V;
  value?: V;

  onIndexValue(index: number, value: V): void;

  removeIndexValue(index: number): void;

  addValue(): void;
}

export const IndexedInput = <V, T extends FormFieldProps<V>>(props: IndexedInputProps<V, T>) => {
  const { index, defaultValue, value, onIndexValue, removeIndexValue, addValue, formFieldComponent, additionalFormFieldProps } = props;
  const disabled = additionalFormFieldProps.disabled ?? false;

  const onValue = useCallback(
    (value: V) => onIndexValue(index, value),
    [index, onIndexValue],
  );

  const removeValue = useCallback(
    () => removeIndexValue(index),
    [index, removeIndexValue],
  );

  return (
    <div className={styles.singleInputContainer}>
      <SingleInput
        formFieldComponent={formFieldComponent}
        additionalFormFieldProps={additionalFormFieldProps}
        formFieldProps={{ defaultValue, onValue, value }}
      />
      {index > 0
        ? <button type="button" className={styles.removeButton} onClick={removeValue} disabled={disabled}/>
        : <button type="button" className={styles.addButton} onClick={addValue} disabled={disabled}/>}
    </div>
  );
};
